import '../css/App.css';
import BlocklyWS from './BlocklyWS';

import React, { Component } from 'react'
import BlockProvider from './blockSystem/BlockProvider';
import NavBar from './navigationBar/NavBar';
import ProgramCollector from './blockSystem/ProgramCollector';
import ProgramParser from './blockSystem/ProgramParser';
import CodeUploader from './uploadSystem/CodeUploaderMicropython';
import ToastHandler from './ToastSystem';
import EventHandler from './eventSystem/EventHandler';
import Event from './eventSystem/Event';
import { download, openFile } from './utils/FileDownloader';
import LibraryManager, { LibrariesOutdated } from './uploadSystem/LibraryManager';
import { NoMicropython } from './uploadSystem/micropython';
import ConsoleSystem from './consoleSystem/consoleSystem';

export default class App extends Component {
  constructor(props) {
    super(props)
    this.blockProvider = new BlockProvider()
    this.programCollector = new ProgramCollector()
    this.programParser = new ProgramParser()
    this.codeUploader = new CodeUploader()
    this.libraryUploader = new LibraryManager()
    this.consoleSystem = ConsoleSystem.getInstance()
    this.blockProvider.prepareBlockly()
    this.libraryUploader.initializeLibrary()
    this.runProgram = this.runProgram.bind(this)
    this.downloadProgram = this.downloadProgram.bind(this)
    this.openProgram = this.openProgram.bind(this)
    this.changeFilename = this.changeFilename.bind(this)
    this.wsRef = React.createRef()
    this.state = { "filename": "Neues Program" }
    if (!this.codeUploader.isSupported()) {
      throw Error("WebUSB is not supported!")
    }


  }
  handleError(e) {
    console.log(e)
    EventHandler.gI().triggerEvent(new Event(Event.ERROR, `Upload failed! ${e.message}`, true))

  }

  async runProgramAsync(){
    EventHandler.gI().triggerEvent(new Event(Event.INFO, "Der Upload wurde gestartet!", true))
    try {
      const programAST = this.programCollector.getProgramAST()
      let parsedProgram = this.programParser.parseProgram(programAST)

      console.log(parsedProgram)
      await this.codeUploader.connect()

      await this.libraryUploader.checkForBaseLibraries(this.codeUploader)
      console.log("Uploading program....")
      //this.libraryUploader.checkForLibaries(this.codeUploader)
      await this.codeUploader.upload(parsedProgram)
      EventHandler.gI().triggerEvent(new Event(Event.INFO, "Der Code wurde geuploadet! Der Code wird in einigen Sekunden ausgeführt!", true))
      await this.codeUploader.reset()
    } catch (e) {
      if(e instanceof NoMicropython) {
        EventHandler.gI().triggerEvent(new Event(Event.ERROR, `Es konnte keine Verbindung zum Board hergestellt werden! Bitte installiere Micropython auf deinem Board!`, true))
      } else if (e instanceof LibrariesOutdated) {
        EventHandler.gI().triggerEvent(new Event(Event.ERROR, `Bitte aktualisiere die Bibliothek auf dem Board!`, true))
      } else {
        this.handleError(e)
      }
    }
  }
  runProgram() {
    this.runProgramAsync()
  }
  handleProgramLoaded(programXML, filename) {
    this.wsRef.current.setWorkspaceXml(programXML)
    this.changeFilename(filename)

  }
  openProgram() {
    openFile(this.handleProgramLoaded.bind(this))
  }



  downloadProgram() {
    const program = this.programCollector.getProgramXML()

    let name = this.state.filename
    if (name === "") {
      name = " "
    }
    download(name + ".xml", program)
  }

  changeFilename(newFilename) {
    console.log(newFilename)
    this.setState({ filename: newFilename })
  }

  render() {
    let callbacks = {
      "runProgram": this.runProgram,
      "openProgram": this.openProgram,
      "downloadProgram": this.downloadProgram,
      "changeFilename": this.changeFilename
    }
    return (
      <div>
        <ToastHandler />
        <NavBar callbacks={callbacks} filename={this.state.filename} />
        <BlocklyWS ref={this.wsRef} programCollector={this.programCollector} blockProvider={this.blockProvider} />

      </div>
    );
  }
}